<template>
  <v-card height="unset">
    <v-list max-height="300" style="overflow-y: scroll">
      <v-list-item
        id="filter-item-no-filter"
        class="global-filter-item"
        :class="{ 'highlight-selected-filter': currentGlobalFilter === undefined }"
        :disabled="currentGlobalFilter === undefined"
        @click="selectGlobalFilter(undefined)"
      >
        <v-list-item-title
          id="filter-item-title-no-filter"
          :class="props.currentGlobalFilter ? '' : 'font-weight-bold'"
        >
          {{ labels.GLOBAL_FILTER.NO_FILTER_APPLIED }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-for="(filter, index) in globalFilters"
        :id="`filter-item-${index}`"
        :key="index"
        class="global-filter-item"
        :class="highlightSelectedGlobalFilter(filter)"
        :disabled="filter.name === props.currentGlobalFilter?.name"
        @click="selectGlobalFilter(filter)"
      >
        <v-list-item-title
          :id="`filter-item-title-${index}`"
          :class="filter.name === props.currentGlobalFilter?.name ? 'font-weight-bold' : ''"
        >
          {{ filter?.name }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="globalFilters.length === 0">
        {{ labels.GLOBAL_FILTER.NO_FILTERS_AVAILABLE }}
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script lang="ts" setup>
  import { useGlobalFilterStore } from '../../stores/globalFilterStore'
  import { GlobalFilter } from '@/models'
  import labels from '@/translations/labels.json'
  import { storeToRefs } from 'pinia'
  import { onMounted } from 'vue'
  import { useProjectStore } from '@/stores/projectStore'
  import { parseIntUndefined } from '@/utils/helpers'
  import { useRoute } from 'vue-router'

  const globalFilterStore = useGlobalFilterStore()
  const { globalFilters } = storeToRefs(globalFilterStore)
  const { currentProject } = storeToRefs(useProjectStore())

  const route = useRoute()

  interface Props {
    currentGlobalFilter: GlobalFilter | undefined
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (event: 'closeFilterMenu'): void
  }>()

  onMounted(() => {
    if (currentProject?.value) {
      globalFilterStore.loadGlobalFiltersFromApi(
        currentProject.value.id,
        parseIntUndefined(route.query.filter as string),
      )
    }
  })

  function selectGlobalFilter(filter?: GlobalFilter): void {
    globalFilterStore.applyGlobalFilter(filter)
    emit('closeFilterMenu')
  }

  function highlightSelectedGlobalFilter(filter: GlobalFilter): string {
    if (filter.id === props.currentGlobalFilter?.id) {
      return 'highlight-selected-filter'
    }

    return ''
  }
</script>

<style lang="scss" scoped>
  // used dynamically (title color change)
  .highlight-selected-filter {
    background-color: rgb(var(--v-theme-itemis-analyze-secondary));
  }
  .select-filter-style {
    opacity: 70%;
    max-width: 300px;
    min-width: 300px;
  }
</style>
